const NHL_HEADER_HEIGHT = 64;
const WEB_VIEW_HEIGHT = 0;

export const isWebview = () => window.location.search.includes('wv=true');
export const HEADER_HEIGHT = isWebview() ? WEB_VIEW_HEIGHT : NHL_HEADER_HEIGHT;
